import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import SystemCreditsUsageReportComponent from './SystemCreditsUsageReportPage';

import { set } from '../../../store/actions/pages';
import { dateEquators, integerEquators, StringEquators } from '../../../store/constants/pages';
import { createCurrencyDataField, createIconDataField, createNumberDataField, createStringDataField, createTimestampField } from '../../../util/format';
import { createFilteredSortedDataSelector } from '../../../util/selector';
import { systemCreditsUsageReportLanding, systemDownloadCreditUsageReport, systemResetCreditUsageReport } from "../../../store/actions/creditUsage";
import { getEndDate, getStartDate } from "../../../util/date";

const DEFAULT_SORT = [{ id: 'userName', direction: 'asc' }];

const selectFields = createSelector(
    () => [
        createStringDataField('userName', 'User Name', { sortable: true, equators: StringEquators }),
        createStringDataField('userRole', 'User Role', { sortable: true, equators: StringEquators }),
        createStringDataField('processingType', 'Processing Type', { sortable: true, equators: StringEquators }),
        createNumberDataField('creditCount', 'Credit Count', { sortable: true, equators: integerEquators }),
        createStringDataField('timestamp', 'Timestamp', { sortable: true, equators: dateEquators }),
    ]
);

const selectDataList = (state) => state.creditUsage.systemData;

const selectFilteredFields = createSelector(
    selectFields,
    (fields) => {
        return fields.map(field => field.id);
    }
);

const selectSort = createSelector(
    (state, props) => state.pages[`system-credits-usage-report-landing`]?.sort,
    (sort) => sort || DEFAULT_SORT,
);

const selectFilteredData = createFilteredSortedDataSelector(
    selectFilteredFields,
    (state, props) => state.pages[`system-credits-usage-report-landing`]?.filter,
    selectSort,
    selectDataList,
);

const initialDates = () => {
    return {
        beginDate: getStartDate('Last12Months'),
        endDate: getEndDate('Last12Months'),
    }
}

export const SystemCreditsUsageReport = connect(
    () => {
        return (state, props) => ({
            listPending: state.creditUsage.systemList.pending,
            fields: selectFields(state as never),
            filteredData: selectFilteredData(state, props),
            order: state.pages[`system-credits-usage-report-landing`]?.order,
            filter: state.pages[`system-credits-usage-report-landing`]?.filter,
            sort: selectSort(state, props),
            initialDates: initialDates,
            downloadReportPending: state.creditUsage.systemDownload.pending,
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            creditsUsageReportLanding: systemCreditsUsageReportLanding,
            downloadCreditUsageReport: systemDownloadCreditUsageReport,
            setFilter: (value) => set(`system-credits-usage-report-landing`, 'filter', value),
            setOrder: (value) => set(`system-credits-usage-report-landing`, 'order', value),
            setSort: (value) => set(`system-credits-usage-report-landing`, 'sort', value),
            resetTable: systemResetCreditUsageReport
        }, dispatch)
    })
)(injectIntl(SystemCreditsUsageReportComponent));
